
angular.module('mean.messages').filter('unsafe', function($sce) {
    return function(val) {
        return $sce.trustAsHtml(val);
    };
});



// WEBPACK FOOTER //
// ./packages/custom/messages/public/filters/messages.js